module.exports = __webpack_public_path__ + "static/img/completion-working-confirm-icon.9c09bfa7.png";